module.exports = __webpack_public_path__ + "static/media/21ECLAC37.95c5c95a.jpg";